export default "__VITE_ASSET__wBciN8vN__"